<template>
  <transition name="fade" appear>
    <div :class="'app-container ' + theme">
      <Sidebar
        v-if="loggedIn && $route.path !== '/promptmultifactor'"
        :menu-items="sidebarMenuItems"
      />

      <div>
        <!-- condensed sidebar for the sign in experience -->
        <DesktopSideBar v-if="!loggedIn" :menu-items="[]" />

        <!--<div class="gtranslate_wrapper"></div>
        <script type="application/javascript">window.gtranslateSettings = {"default_language":"en","native_language_names":true,"detect_browser_language":true,"languages":["en","es"],"wrapper_selector":".gtranslate_wrapper","flag_style":"3d","alt_flags":{"en":"usa","es":"mexico"}}</script>
        <script type="application/javascript" src="https://cdn.gtranslate.net/widgets/latest/float.js" defer></script>-->
      </div>
      

      <AppContent>
        <top-nav
          v-if="loggedIn && $route.path !== '/promptmultifactor'"
          :sidebar-items="sidebarMenuItems"
        />

        <Page>
          <transition class="flex-grow-2" name="fade" mode="out-in" appear>
            <router-view />
          </transition>
        </Page>
      </AppContent>

      <Overlays />

      <div tabindex="0" aria-label="end of page"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import Page from '@/containers/Page'
import AppContent from '@/containers/AppContent'

// Components
import Sidebar from '@/components/Sidebar'
import TopNav from '@/components/navs/Top/index'
import DesktopSideBar from '@/components/Sidebar/components/Desktop'
//
import Overlays from '@/components/Overlays'

import { windowStore } from '@/utilities/window/store'

import { sidebarMenuItems } from '@/utilities/sidebarMenuItems/Management'

import { hoaUtility } from '@/services/Hoa/store'

export default {
  components: {
    DesktopSideBar,
    Page,
    AppContent,
    TopNav,
    Sidebar,
    Overlays
  },

  data: function() {
    return {
      theme: 'theme-light',
      myEnhancedFeatures: []
    }
  },

  async beforeMount() {},

  computed: {
    ...mapGetters('user', ['authUser', 'loggedIn', 'hoaId']),
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    }),
    ...mapState({
      subscription: state => state.subscription.subscription,
      hoaFeatures: state => state.subscription.hoaFeatures,
      hoaAddOnFeatures: state => state.subscription.selectedHoaId
    }),
    sidebarMenuItems() {
      return sidebarMenuItems({
        hoaId: this.hoaId,
        enhancedFeatures: this.myEnhancedFeatures
      })
    }
  },

  watch: {
    //This is necessary because the sidebar needs reloaded when the single load features are populated
    myEnhancedFeatures() {
      if (this.myEnhancedFeatures && this.myEnhancedFeatures.length > 0) {
        this.sidebarMenuItems
      }
    }
  },

  methods: {
    /**
     * Status of item, alter animation name based on action.
     */
    async retrieveFeatureList() {
      console.debug('in retrieveFeatureList()...')
      await hoaUtility
        .dispatch('getEnabledFeaturesList', {
          hoaID: this.hoaId
        })
        .then(({ list }) => {
          if (list && list.length > 0) {
            console.debug(
              'getEnabledFeaturesList========AppManagement=========================' +
                JSON.stringify(list)
            )

            this.myEnhancedFeatures = list
          }
        })

      return []
    }
  },

  async mounted() {
    this.$store.dispatch('alerts/retrieveUnreadListOnRepeat')

    if (
      this.myEnhancedFeatures &&
      this.myEnhancedFeatures.length == 0 &&
      this.hoaId !== undefined &&
      this.hoaId
    ) {
      await this.retrieveFeatureList()
    }
  },

  beforeCreate() {
    windowStore.dispatch('init')
  }
}
</script>
